export const searchHelpPages = /* GraphQL */ `
  query SearchHelpPages(
    $filter: SearchableHelpPageFilterInput
    $sort: SearchableHelpPageSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchHelpPages(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        active
        isLive
        url
        topic
        name
        content
        kbFiles {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        kbMedia {
          bucket
          region
          key
          type
          createdBy
          createdAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      nextToken
      # total
    }
  }
`;
